import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import styles from './Labels.scss';

// TODO: use labels from static-ui-libarary
export default class LabelBase extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        required: PropTypes.bool,
    };

    static defaultProps = {
        children: null,
        className: void 0,
        required: false,
    };

    /* eslint-disable class-methods-use-this */
    getLabelStyle() {
        console.error('LabelBase.getLabelStyle method needs to be extended');
    }

    render() {
        const { required } = this.props;
        const widgetProps = omit(
            this.props,
            'text',
            'className',
            'styles',
        );

        return (
            <span
                {...widgetProps}
                className={`${required ? styles['text-label-required'] : styles[this.getLabelStyle()]} ${this.props.className}`}
            >
                {this.props.children}
            </span>
        );
    }
}
